import { render, staticRenderFns } from "./Create-Page.vue?vue&type=template&id=1403871b&scoped=true&"
import script from "./Create-Page.vue?vue&type=script&lang=js&"
export * from "./Create-Page.vue?vue&type=script&lang=js&"
import style0 from "./Create-Page.vue?vue&type=style&index=0&id=1403871b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1403871b",
  null
  
)

export default component.exports